<template>
    <b-container>
        <div class="card ">
            <div class="card-header main-card">
                Administración de secretos
            </div>
            <div class="card-body d-flex flex-row">
                <b-form>
                    <b-form-group id="input-group-1" label="Id" label-for="input-1">
                    <b-form-input :value="client_id" v-model="client_id" id="input-1" required class="border"></b-form-input>
                    </b-form-group>

                    <b-form-group id="input-group-2" label="Contraseña" label-for="input-2">
                    <b-input-group>
                        <b-form-input
                            id="input-2"
                            :value="client_secret"
                            v-model="client_secret"
                            :type="passwordFieldType"
                            placeholder="Nueva contraseña"
                            required
                            class="border"
                        ></b-form-input>

                        <b-input-group-append>
                        <b-button variant="outline-primary" @click="switchVisibility">
                            <i :class="passwordFieldType === 'password' ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                        </b-button>
                        </b-input-group-append>
                    </b-input-group>
                    </b-form-group>

                    <b-button
                    :disabled="client_secret == ''"
                    @click="updateDate"
                    variant="primary"
                    >Cambiar datos</b-button>
                </b-form>
            </div>
        </div>
    </b-container>
                
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
        client_id: "",
        client_secret: "",
        password: "",
        passwordFieldType: "password"
        };
    },
    computed: {
        ...mapGetters(["trekksoftClient", 'activeTab', 'activeOption'])
    },
    async mounted() {
        try {
        await this.$store.dispatch("trekksoft/getTrekksoftClientName");
        } catch (ex) {
        this.error = "Failed to load data";
        } finally {
        this.client_id = this.trekksoftClient;
        }
    },
    methods: {
        switchVisibility() {
        this.passwordFieldType =
            this.passwordFieldType === "password" ? "text" : "password";
        },
        updateDate() {
        const client_id_data = {
            key: "client_id",
            value: this.client_id
        };
        const client_secret_data = {
            key: "client_secret",
            value: this.client_secret
        };
        this.$store.dispatch(
            "trekksoft/changeTrekksoftClientData",
            client_id_data
        );
        this.$store.dispatch(
            "trekksoft/changeTrekksoftClientData",
            client_secret_data
        );

        this.client_secret = "";
        }
    }
}
</script>